import _Tooltip from "@mui/material/Tooltip";
import _Skeleton from "@mui/material/Skeleton";
import _Box from "@mui/material/Box";
import _Typography from "@mui/material/Typography";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { useTranslation } from 'react-i18next';
function StatsCard({
  title,
  items,
  hasIcons,
  children,
  ...props
}) {
  const maxCount = items ? Math.max(...items.map(({
    count
  }) => count)) : 0;
  return /*#__PURE__*/React.createElement(_Box, {
    bgcolor: "#fff",
    borderRadius: 2,
    boxSizing: "border-box",
    display: "flex",
    flexDirection: {
      xs: 'column',
      lg: 'row'
    },
    gap: 3,
    height: "100%",
    padding: 3
  }, /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    gap: 3
  }, /*#__PURE__*/React.createElement(_Typography, {
    fontSize: "1.1rem",
    fontWeight: 600
  }, title), /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: 2
  }, items ? items.map(item => /*#__PURE__*/React.createElement(Item, _extends({
    item: item,
    key: item.key,
    maxCount: maxCount
  }, props))) : new Array(5).fill(null).map((_, index) => /*#__PURE__*/React.createElement(Item, _extends({
    hasIcon: hasIcons,
    key: index,
    maxCount: maxCount
  }, props))))), children);
}
function Item({
  hasIcon,
  respondantsCount,
  progressBarColor,
  progressBarWidth,
  maxCount,
  item
}) {
  const {
    t
  } = useTranslation();
  const percentage = item && respondantsCount ? Math.round(item.count / respondantsCount * 100) : 0;
  return /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 2
  }, /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    flexShrink: 0,
    gap: 2,
    width: progressBarWidth
  }, item?.icon ? /*#__PURE__*/React.createElement("img", {
    src: item.icon,
    style: {
      flexShrink: 0
    },
    width: 24
  }) : hasIcon && /*#__PURE__*/React.createElement(_Skeleton, {
    height: 24,
    variant: "circular",
    width: 24
  }), /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(_Typography, {
    variant: "body2"
  }, item?.label || /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: "100%"
  })), item?.caption && /*#__PURE__*/React.createElement(_Typography, {
    color: "textSecondary",
    variant: "caption"
  }, item.caption))), /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    flexGrow: 1,
    gap: 2
  }, item ? /*#__PURE__*/React.createElement(_Tooltip, {
    placement: "left",
    title: t('commons.transport_habits.respondents', {
      count: item.count
    })
  }, /*#__PURE__*/React.createElement(_Box, {
    bgcolor: percentage > 0 ? item.progressBarColor || progressBarColor : '#dde0e7',
    borderRadius: 1,
    flexShrink: 0,
    height: 16,
    minWidth: 8,
    width: `calc((100% - 72px) * ${item.count / maxCount})`
  })) : /*#__PURE__*/React.createElement(_Skeleton, {
    height: 16,
    variant: "rounded",
    width: "calc(100% - 72px)"
  }), /*#__PURE__*/React.createElement(_Box, {
    flexShrink: 0,
    width: 56
  }, /*#__PURE__*/React.createElement(_Typography, {
    noWrap: true,
    fontSize: "1.1rem",
    fontWeight: 600
  }, item ? `${percentage} %` : /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: "100%"
  })))));
}
export default StatsCard;